import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vehicleFilter: { name: "vehImei", list: [], search: null },
  vehicleDetails: {},
};

const eolSlice = createSlice({
  name: "eol",
  initialState,
  reducers: {
    reset: () => initialState,
    setVehicleFilter: (state, action) => {
      return {
        ...state,
        vehicleFilter: action.payload,
      };
    },
    setVehicleDetails: (state, action) => {
      return {
        ...state,
        vehicleDetails: action.payload,
      };
    },
  },
});

export const { setVehicleFilter, setVehicleDetails } = eolSlice.actions;
export default eolSlice.reducer;
